export const PREFERRED_LOGIN_TYPES = {
    OTP_LOGIN: 'otp_login',
    PASSWORD_LOGIN: 'password_login',
};
export const LOCAL = 'local';
export const STAGE_URL = 'https://www.msmaster.qa.paypal.com';
